import { config } from './config';

export async function getProductQuestions(productLink, sessionId, customerId, website, productNumber, userId, testId, testGroupId) {
  try {
    const userAgent = navigator.userAgent;
    const body = {
      url: productLink,
      ua: userAgent,
      site: website,
      c_id: customerId,
      se_id: sessionId,
      p_n: productNumber ? productNumber : null,
      u_id: userId ? userId : null,
      test_id: testId ? testId : null,
      test_group_id: testGroupId ? testGroupId : null
    }

    const response = await fetch(`${config.BASE_URL}/chat/onboarding`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching gateway info:', error);
    throw error;
  }
}
